import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/common/Seo";
import PrerenderStatus from "@/components/common/PrerenderStatus";

export default function NotFoundPage() {
  return (
    <div className="max-w-2xl mx-auto px-4 md:px-8 py-24 text-center">
      <Seo title="Not found" noindex />
      <PrerenderStatus code={404} />
      <div className="font-display text-8xl font-black text-[color:var(--brand-blue)]">404</div>
      <h1 className="mt-2 font-display text-2xl font-bold text-slate-900">Ka pai — but this page has gone walkabout.</h1>
      <p className="mt-2 text-slate-500">The listing may have expired or the URL is wrong.</p>
      <Link to="/" className="mt-8 inline-block rounded-full bg-[color:var(--brand-orange)] text-white font-bold px-6 py-3">
        Back to Allsale Classified
      </Link>
    </div>
  );
}
